import { Accent, Heading } from './SectionHeader.styles';
import type { SectionHeaderProps } from './SectionHeader.types';

export function SectionHeader({ title, subtitle }: SectionHeaderProps) {
  return (
    <Heading>
      {title}
      {subtitle && (
        <>
          {' '}
          <Accent>{subtitle}</Accent>
        </>
      )}
    </Heading>
  );
}
